import styled from 'styled-components'
import GridListCard from './GridListCard'
import { DndContext, PointerSensor, TouchSensor, useSensor, useSensors, closestCenter } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable'
import { restrictToVerticalAxis, restrictToParentElement } from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'
import { Icon_Drag } from '../../styles/icons'

const CardList = styled.div`
    @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
        display: none;
    }
`

const SortableCardWrapper = styled.div`
    position: relative;
`

const DragHandle = styled.div`
    position: absolute;
    right: -0.5rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: grab;
    color: ${({ theme }) => theme.text?.secondary || '#aaa'};
    display: flex;
    align-items: center;
    padding: 0.25rem;
    touch-action: none;
    opacity: 0.4;

    &:hover {
        opacity: 1;
    }

    &:active {
        cursor: grabbing;
    }
`

const SortableMobileCard = ({ children, sortableId }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: sortableId })
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    }

    return (
        <SortableCardWrapper ref={setNodeRef} style={style}>
            <DragHandle {...attributes} {...listeners}>
                {Icon_Drag}
            </DragHandle>
            {children}
        </SortableCardWrapper>
    )
}

const GridListTable_m = ({
    rows,
    config,
    onAction,
    onUpdateCell,
    useStore,
    entity,
    reorderable,
    onReorder,
    dirtyRows = new Set(),
    savedRows = new Set(),
}) => {
    const mobileConfig = config.mobile

    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
        useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 5 } })
    )

    const handleDragEnd = (event) => {
        const { active, over } = event
        if (!over || active.id === over.id) return
        const oldIndex = rows.findIndex((_, i) => `grid-m-${i}` === active.id)
        const newIndex = rows.findIndex((_, i) => `grid-m-${i}` === over.id)
        if (oldIndex === -1 || newIndex === -1) return
        onReorder?.(oldIndex, newIndex)
    }

    if (!mobileConfig) return null

    const cards = rows.map((row, i) => (
        <GridListCard
            key={row.id || row._key || i}
            row={row}
            rowIdx={i}
            mobileConfig={mobileConfig}
            config={config}
            onAction={onAction}
            onUpdateCell={onUpdateCell}
            useStore={useStore}
            entity={entity}
            isDirty={dirtyRows.has(i)}
            isSaved={savedRows.has(i)}
        />
    ))

    if (reorderable) {
        const sortableIds = rows.map((_, i) => `grid-m-${i}`)
        return (
            <CardList>
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                    modifiers={[restrictToVerticalAxis, restrictToParentElement]}
                >
                    <SortableContext items={sortableIds} strategy={verticalListSortingStrategy}>
                        {rows.map((row, i) => (
                            <SortableMobileCard key={row.id || row._key || i} sortableId={`grid-m-${i}`}>
                                {cards[i]}
                            </SortableMobileCard>
                        ))}
                    </SortableContext>
                </DndContext>
            </CardList>
        )
    }

    return (
        <CardList>
            {cards}
        </CardList>
    )
}

export default GridListTable_m
